/** Approximate rendered width of an SVG text run, in px. */
const AVG_GLYPH_RATIO = 0.55;

export const estimateTextWidth = (text: string, fontSize: number): number =>
  text.length * fontSize * AVG_GLYPH_RATIO;

/** Split an axis label across at most two balanced lines when one line overflows. */
export const splitAxisLabel = (label: string, maxWidth: number, fontSize: number): string[] => {
  if (estimateTextWidth(label, fontSize) <= maxWidth) return [label];

  const words = label.split(' ').filter(Boolean);
  if (words.length < 2) return [label];

  let best = { at: 1, spread: Infinity };
  for (let at = 1; at < words.length; at++) {
    const head = words.slice(0, at).join(' ');
    const tail = words.slice(at).join(' ');
    const spread = Math.abs(head.length - tail.length);
    if (spread < best.spread) best = { at, spread };
  }
  return [words.slice(0, best.at).join(' '), words.slice(best.at).join(' ')];
};

/** Shrink an axis label only as far as the configured readability floor. */
export const fitFontSize = (
  lines: string[],
  maxWidth: number,
  baseSize: number,
  minSize = 8,
): number => {
  const widest = Math.max(...lines.map((line) => estimateTextWidth(line, baseSize)));
  if (widest <= maxWidth) return baseSize;
  return Math.max(minSize, Math.floor(baseSize * (maxWidth / widest)));
};
